'use strict';

var _regeneratorRuntime = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _require = require('events');

var EventEmitter = _require.EventEmitter;

var dgram = require('dgram');

var ms = require('ms');

var createDebugLogger = require('debug');

var LRUCache = require('lru-cache');

var message = require('./message');

var _require2 = require('../util');

var keccak256 = _require2.keccak256,
    pk2id = _require2.pk2id,
    createDeferred = _require2.createDeferred;
var debug = createDebugLogger('devp2p:dpt:server');
var VERSION = 0x04;
var createSocketUDP4 = dgram.createSocket.bind(null, 'udp4');

var Server =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Server, _EventEmitter);

  function Server(dpt, privateKey, options) {
    var _this2;

    _classCallCheck(this, Server);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Server).call(this));
    _this2._dpt = dpt;
    _this2._privateKey = privateKey;
    _this2._timeout = options.timeout || ms('10s');
    _this2._endpoint = options.endpoint || {
      address: '0.0.0.0',
      udpPort: null,
      tcpPort: null
    };
    _this2._requests = new Map();
    _this2._parityRequestMap = new Map();
    _this2._requestsCache = new LRUCache({
      max: 1000,
      maxAge: ms('1s'),
      stale: false
    });
    var createSocket = options.createSocket || createSocketUDP4;
    _this2._socket = createSocket();

    _this2._socket.once('listening', function () {
      return _this2.emit('listening');
    });

    _this2._socket.once('close', function () {
      return _this2.emit('close');
    });

    _this2._socket.on('error', function (err) {
      return _this2.emit('error', err);
    });

    _this2._socket.on('message', function (msg, rinfo) {
      try {
        _this2._handler(msg, rinfo);
      } catch (err) {
        _this2.emit('error', err);
      }
    });

    return _this2;
  }

  _createClass(Server, [{
    key: "bind",
    value: function bind() {
      var _this$_socket;

      this._isAliveCheck();

      debug('call .bind');

      (_this$_socket = this._socket).bind.apply(_this$_socket, arguments);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$_socket2;

      this._isAliveCheck();

      debug('call .destroy');

      (_this$_socket2 = this._socket).close.apply(_this$_socket2, arguments);

      this._socket = null;
    }
  }, {
    key: "ping",
    value: function ping(peer) {
      var _this = this;

      return (0, _asyncToGenerator3.default)(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var rckey, promise, hash, deferred, rkey;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this._isAliveCheck();

                rckey = "".concat(peer.address, ":").concat(peer.udpPort);
                promise = _this._requestsCache.get(rckey);

                if (!(promise !== undefined)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", promise);

              case 5:
                hash = _this._send(peer, 'ping', {
                  version: VERSION,
                  from: _this._endpoint,
                  to: peer
                });
                deferred = createDeferred();
                rkey = hash.toString('hex');

                _this._requests.set(rkey, {
                  peer: peer,
                  deferred: deferred,
                  timeoutId: setTimeout(function () {
                    if (_this._requests.get(rkey) !== undefined) {
                      debug("ping timeout: ".concat(peer.address, ":").concat(peer.udpPort, " ").concat(peer.id && peer.id.toString('hex')));

                      _this._requests.delete(rkey);

                      deferred.reject(new Error("Timeout error: ping ".concat(peer.address, ":").concat(peer.udpPort)));
                    } else {
                      return deferred.promise;
                    }
                  }, _this._timeout)
                });

                _this._requestsCache.set(rckey, deferred.promise);

                return _context.abrupt("return", deferred.promise);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }))();
    }
  }, {
    key: "findneighbours",
    value: function findneighbours(peer, id) {
      this._isAliveCheck();

      this._send(peer, 'findneighbours', {
        id: id
      });
    }
  }, {
    key: "_isAliveCheck",
    value: function _isAliveCheck() {
      if (this._socket === null) throw new Error('Server already destroyed');
    }
  }, {
    key: "_send",
    value: function _send(peer, typename, data) {
      var _this3 = this;

      debug("send ".concat(typename, " to ").concat(peer.address, ":").concat(peer.udpPort, " (peerId: ").concat(peer.id && peer.id.toString('hex'), ")"));
      var msg = message.encode(typename, data, this._privateKey); // Parity hack
      // There is a bug in Parity up to at lease 1.8.10 not echoing the hash from
      // discovery spec (hash: sha3(signature || packet-type || packet-data))
      // but just hashing the RLP-encoded packet data (see discovery.rs, on_ping())
      // 2018-02-28

      if (typename === 'ping') {
        var rkeyParity = keccak256(msg.slice(98)).toString('hex');

        this._parityRequestMap.set(rkeyParity, msg.slice(0, 32).toString('hex'));

        setTimeout(function () {
          if (_this3._parityRequestMap.get(rkeyParity) !== undefined) {
            _this3._parityRequestMap.delete(rkeyParity);
          }
        }, this._timeout);
      }

      this._socket.send(msg, 0, msg.length, peer.udpPort, peer.address);

      return msg.slice(0, 32); // message id
    }
  }, {
    key: "_handler",
    value: function _handler(msg, rinfo) {
      var _this4 = this;

      var info = message.decode(msg);
      var peerId = pk2id(info.publicKey);
      debug("received ".concat(info.typename, " from ").concat(rinfo.address, ":").concat(rinfo.port, " (peerId: ").concat(peerId.toString('hex'), ")")); // add peer if not in our table

      var peer = this._dpt.getPeer(peerId);

      if (peer === null && info.typename === 'ping' && info.data.from.udpPort !== null) {
        setTimeout(function () {
          return _this4.emit('peers', [info.data.from]);
        }, ms('100ms'));
      }

      switch (info.typename) {
        case 'ping':
          Object.assign(rinfo, {
            id: peerId,
            udpPort: rinfo.port
          });

          this._send(rinfo, 'pong', {
            to: {
              address: rinfo.address,
              udpPort: rinfo.port,
              tcpPort: info.data.from.tcpPort
            },
            hash: msg.slice(0, 32)
          });

          break;

        case 'pong':
          var rkey = info.data.hash.toString('hex');

          var rkeyParity = this._parityRequestMap.get(rkey);

          if (rkeyParity) {
            rkey = rkeyParity;

            this._parityRequestMap.delete(rkeyParity);
          }

          var request = this._requests.get(rkey);

          if (request) {
            this._requests.delete(rkey);

            request.deferred.resolve({
              id: peerId,
              address: request.peer.address,
              udpPort: request.peer.udpPort,
              tcpPort: request.peer.tcpPort
            });
          }

          break;

        case 'findneighbours':
          Object.assign(rinfo, {
            id: peerId,
            udpPort: rinfo.port
          });

          this._send(rinfo, 'neighbours', {
            peers: this._dpt.getClosestPeers(info.data.id)
          });

          break;

        case 'neighbours':
          this.emit('peers', info.data.peers.map(function (peer) {
            return peer.endpoint;
          }));
          break;
      }
    }
  }]);

  return Server;
}(EventEmitter);

module.exports = Server;